import * as bynderAxios from '../../../helpers/customAxios';

import { Input, UpdateInput, OOOResponse, User } from '../types';

export const OOO_ROUTES = {
	BASE: '/user_out_of_office',
	LIST: '/list_by_main',
	USER_SEARCH_BASE: '/v7/identity/users/list/',
	USER_SEARCH_PARAM: '?search_term=',
};

export const API = {
	save: (data: Input) => bynderAxios.post({ url: OOO_ROUTES.BASE, data }),
	update: (data: UpdateInput) => bynderAxios.put({ url: `${OOO_ROUTES.BASE}/${data.id}`, data }),
	check: (): Promise<OOOResponse[]> =>
		bynderAxios.get({ url: `${OOO_ROUTES.BASE}${OOO_ROUTES.LIST}` }),
	remove: (id: string) => bynderAxios.deletes({ url: `${OOO_ROUTES.BASE}/${id}` }),
	searchIdentity: (value: string): Promise<User[]> =>
		bynderAxios.get({
			url: `${OOO_ROUTES.USER_SEARCH_BASE}`,
			config: { params: { search_term: value } },
			jwt: true,
		}),
};
